// import { useState, useEffect } from 'react';
// hook wrapper for xApi service
const useXapi = useService => {
  const { validatecanSendXapiRequests } = require('../services/xApiService');
  let xApiEvent = hook => {
    if (validatecanSendXapiRequests()) {
      console.log('xAPI Hook Placeholder :>> ', hook);
    }
  };
  if (useService) {
    const { xApiEvent } = require('../services/xApiService');
    return { xApiEvent };
  }
  return { xApiEvent };
};

export default useXapi;
